import styled from 'styled-components';

export const Radius = styled.div`
    border-radius: 10px;
    display: inline-block;
    padding: 1px 15px 0px 10px;
    font-size: 12px;
    height: 22px;
    background: var(--primary);
`;
